import { Injectable } from '@angular/core';

const NO_MAINTENANCE = "0";
const MAINTENANCE_MODE_1 = "1";
const MAINTENANCE_MODE_2 = "2";

@Injectable()
export class MaintenanceService {

  code: string = NO_MAINTENANCE;

  constructor(
  ) {
  }

  /**
   * メンテナンスコードを更新する
   * @param maintenanceCode: string
   * @return void
   */
  setCode(maintenanceCode: string): void {
    this.code = maintenanceCode;
  }

  /**
   * モード1
   * オフラインメンテンス: 一部機能利用可能
   * @return boolean
   */
  isMode1(): boolean {
    return this.code === MAINTENANCE_MODE_1;
  }

  /**
   * モード2
   * 強制メンテナンス: 全機能使用停止
   */
  isMode2(): boolean {
    return this.code === MAINTENANCE_MODE_2;
  }

}



// WEBPACK FOOTER //
// ./src/providers/maintenance.service.ts